module.exports = __webpack_public_path__ + "static/media/Novo_Logo-solid-green.ba2ee188.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Novo_Logo-solid-green.svg
// module id = 221
// module chunks = 0